var _rect, _rect2, _rect3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnmark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 79,
    viewBox: "0 0 25 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5127,
    y: 25.1646,
    width: 2.68116,
    height: 14.2995,
    rx: 1.34058,
    fill: "white",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5127,
    y: 44.8265,
    width: 2.68116,
    height: 14.2995,
    rx: 1.34058,
    fill: "white",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5127,
    y: 64.4883,
    width: 2.68116,
    height: 14.2995,
    rx: 1.34058,
    fill: "white",
    fillOpacity: 0.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4418,
    cy: 12.7294,
    r: 12.4408,
    fill: "#7F818B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmark);
export default __webpack_public_path__ + "static/media/unmark.62ca03bf19f050ec533a82f36f2c1c61.svg";
export { ForwardRef as ReactComponent };